import React from "react";
import "./Home.css";

export default function Home() {
  return (
    <div className="Home">
      <div className="lander">
        <h1>OOLA</h1>
        <p className="text-muted">Outside of Locus Application</p>
      </div>
    </div>
  );
}